import React from 'react'

import { Item, Background, Text, Check } from '../../ListItem'

function ChallengeItem (props){
  return (
    <Item selected={ props.selected } onClick={ props.changeChallenge }>
      <Background selected={ props.selected }/>
      <Text selected={ props.selected }>{ props.text }</Text>
      <Check onClick={ props.checkChallenge } selected={ props.selected } completed={ props.completed }>{ props.completed ? "✔️" : "❌" }</Check>
    </Item>
  )
}

export default ChallengeItem